module.exports = __webpack_public_path__ + "static/media/oil-can.d1a7afd5.svg";